import {
    Card,
    Col,
    Progress,
    Radio,
    Row,
    Select,
    Skeleton,
    Tabs,
    Typography,
    Descriptions,
    Table,
    Tag,
    Badge,
    Tooltip,
    Dropdown,
    Menu,
    Button,
  } from "antd";
  
  import { DownOutlined } from "@ant-design/icons";
  import React, { useContext, useEffect, useState } from "react";
  import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend } from "recharts";
  
  import apiPath from "../../constants/apiPath";
  import { AppStateContext } from "../../context/AppContext";
  import { Severty, ShowToast } from "../../helper/toast";
  import useRequest from "../../hooks/useRequest";
  import { useNavigate } from "react-router";
  import { useAuthContext } from "../../context/AuthContext";
  import { Link } from "react-router-dom";
  import "../../assets/styles/dashboard.css";
  import moment from "moment";
  import ImportForm from "../../components/ImportForm";
  
  import LogoImage from "../../assets/images/logo.svg";
  
  import DashbordIcon from "../../assets/images/dashbord-image/dashbord.png";
  import NotificationIcon from "../../assets/images/notification.svg";
  import AppUpdatesIcon from "../../assets/images/dashbord-image/App-Updates.png";
  import ChallengeManagementIcon from "../../assets/images/dashbord-image/Challenge-Management.png";
  import ContentModerationIcon from "../../assets/images/dashbord-image/Content-Moderation.png";
  import LeaderboardIcon from "../../assets/images/dashbord-image/Leaderboard.png";
  import ReportingManagementIcon from "../../assets/images/dashbord-image/Reporting-Management.png";
  import SecurityIcon from "../../assets/images/dashbord-image/Security.png";
  import StoreManagementIcon from "../../assets/images/dashbord-image/Store-Management.png";
  import UserEngagementIcon from "../../assets/images/dashbord-image/User-Engagement.png";
  import UserManagementIcon from "../../assets/images/dashbord-image/User-Management.png";
  import VideoManagementIcon from "../../assets/images/dashbord-image/Video-Management.png";
  
  const { Title, Text } = Typography;
  
  const years = [2024, 2025];
  
  function NewHeader() {
    const { setPageHeading, country } = useContext(AppStateContext);
  
    const { request } = useRequest();
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [importModal, showImportModal] = useState(false);
    const [year, setYear] = useState(years[0]);
    const [period, setPeriod] = useState("monthly");
    const { userProfile } = useAuthContext();
    const [dashboard, setDashboard] = useState();
    const [listing, setListing] = useState([]);
    const [stockData, setStockData] = useState([]);
    const [extraKeys, setExtraKeys] = useState({});
    const [openPosition, setOpenPositions] = useState();
    const [currency, setCurrency] = useState("USD");
  
    const data = [
      { name: "Jan", uv: 4000, pv: 2400, amt: 2400 },
      { name: "Feb", uv: 3000, pv: 1398, amt: 2210 },
      // Add more data points
    ];
  
    const menu = (
      <Menu
        style={{ width: "70px" }}
        onClick={(e) => {
          fetchWalletInfo(e.key);
          setCurrency(e.key);
        }}
      >
        <Menu.Item key="USD">USD</Menu.Item>
        <Menu.Item key="AED">AED</Menu.Item>
        <Menu.Item key="HKD">HKD</Menu.Item>
        <Menu.Item key="SGD">SGD</Menu.Item>
      </Menu>
    );
  
  
  
    const fetchWalletInfo = (currency) => {
      request({
        url: apiPath.getOpenPositions,
        method: "POST",
        data: { currency },
        onSuccess: (data) => {
          if (data.status) {
            setOpenPositions(data);
          } else {
            ShowToast(data?.message, Severty.ERROR);
          }
        },
        onError: (err) => {
          ShowToast(err?.message, Severty.ERROR);
        },
      });
    };
  
    useEffect(() => {
      setPageHeading("Welcome Admin");
      if (!userProfile) return;
  
      setLoading(true);
      request({
        url: apiPath.dashboard + `${year ? `?year=${year}` : ""}`,
        method: "GET",
        onSuccess: ({ data }) => {
          setLoading(false);
          setListing(data?.orders);
          setDashboard(data?.data);
          setExtraKeys(data?.extraKeys?.[0]);
        },
        onError: (error) => {
          setLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    }, [userProfile, refresh]);
  
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleSidebar = () => {
      setIsOpen(!isOpen);
    };
  
    return (
      <>
              <Card className="criclebox mb-3">
                <div className={`toolbar ${isOpen ? "open" : ""}`}>
                  <button className="toggle-button" onClick={toggleSidebar}>
                    ☰
                  </button>
                  <div>
                    <Row gutter={32}>
                      <Col span={24} lg={10}>
                        <div className="icon-container">
                          <Link to="/dashboard" className="toolbar-icon-link">
                            <img
                              src={UserManagementIcon}
                              alt="Dashboard"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/analytics" className="toolbar-icon-link">
                            <img
                              src={ChallengeManagementIcon}
                              alt="Analytics"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/settings" className="toolbar-icon-link">
                            <img
                              src={ContentModerationIcon}
                              alt="Settings"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/notifications" className="toolbar-icon-link">
                            <img
                              src={StoreManagementIcon}
                              alt="Notifications"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/profile" className="toolbar-icon-link">
                            <img
                              src={UserEngagementIcon}
                              alt="Profile"
                              className="toolbar-icon"
                            />
                          </Link>
                        </div>
                      </Col>
                      <Col span={24} lg={4}>
                        <div className="center-point-btn">
                          <Link to="/dashboard" className="toolbar-icon-link">
                            <img
                              src={DashbordIcon}
                              alt="Dashboard"
                              className="toolbar-icon"
                            />
                          </Link>
                        </div>
                      </Col>
                      <Col span={24} lg={10}>
                        <div className="icon-container">
                          <Link to="/dashboard" className="toolbar-icon-link">
                            <img
                              src={ReportingManagementIcon}
                              alt="Dashboard"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/analytics" className="toolbar-icon-link">
                            <img
                              src={ContentModerationIcon}
                              alt="Analytics"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/settings" className="toolbar-icon-link">
                            <img
                              src={AppUpdatesIcon}
                              alt="Settings"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/notifications" className="toolbar-icon-link">
                            <img
                              src={LeaderboardIcon}
                              alt="Notifications"
                              className="toolbar-icon"
                            />
                          </Link>
                          <Link to="/profile" className="toolbar-icon-link">
                            <img
                              src={SecurityIcon}
                              alt="Profile"
                              className="toolbar-icon"
                            />
                          </Link>
                        </div>
                      </Col>
                    </Row>
  
                    {/* Add more icons as needed */}
                  </div>
                </div>
              </Card>
              <Row gutter={[22, 22]} className=" ">
                <Col span={24} lg={20}>
                  <Card className="criclebox">
                    <div className="main-counters-total">
                      <div className="logo-outer">
                        <img src={LogoImage} />
                      </div>
                      <div className="user-counter-box">
                        <h4>Total active users</h4>
                        <div className="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div className="user-counter-box">
                        <h4>Challenges Complate</h4>
                        <div className="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div className="user-counter-box">
                        <h4>New users</h4>
                        <div className="number-of-count">
                          <span>3232</span>
                        </div>
                      </div>
                      <div className="notfy-icon">
                        <img src={NotificationIcon} />
                        <span>2</span>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col span={24} lg={4}>
                  <Card className="criclebox h-100">
                    <div className="date-formate-box">
                      <h6>Date</h6>
                      <h4>31 May 2024</h4>
                    </div>
                    <div className="date-formate-box">
                      <h6>Time</h6>
                      <h4>3 PM</h4>
                    </div>
                  </Card>
                </Col>
              </Row> 
      </>
    );
  }
  
  export default NewHeader;
  